/**
 * Prefer the live store identity color over a possibly stale PWA manifest theme_color.
 */
export function resolveStoreThemeColor({
    identityColor,
    existingThemeColor,
    manifestThemeColor,
} = {}) {
    const candidates = [identityColor, existingThemeColor, manifestThemeColor];
    for (const value of candidates) {
        if (value == null) continue;
        const trimmed = String(value).trim();
        if (trimmed) return trimmed;
    }
    return '';
}

/** Update the document theme-color meta used by browser/PWA chrome. */
export function setDocumentThemeColor(color) {
    if (typeof document === 'undefined') return false;
    const content = String(color || '').trim();
    if (!content) return false;

    let themeColor = document.querySelector('meta[name="theme-color"]');
    if (!themeColor) {
        themeColor = document.createElement('meta');
        themeColor.setAttribute('name', 'theme-color');
        themeColor.setAttribute('id', 'meta-theme-color');
        document.head.appendChild(themeColor);
    }
    themeColor.setAttribute('content', content);
    return true;
}

/** Persist theme_color into slug-scoped PWA branding cache. */
export function persistPwaBrandingThemeColor(slug, themeColor, patch = {}) {
    if (typeof localStorage === 'undefined' || !slug) return null;
    const content = String(themeColor || '').trim();
    if (!content) return null;

    try {
        const existing = JSON.parse(localStorage.getItem(`pwa-branding-${slug}`) || '{}');
        const next = {
            ...existing,
            ...patch,
            theme_color: content,
        };
        localStorage.setItem(`pwa-branding-${slug}`, JSON.stringify(next));
        return next;
    } catch (_) {
        return null;
    }
}
